import request from '@/utils/request'

let Ma_risk_controlApi = {

  /*风险管控列表*/
  list(data) {
    return request._post('/shop/plus.ma_risk_control.Index/index', data);
},
/*添加风险管控*/
add(data) {
    return request._post('/shop/plus.ma_risk_control.Index/add', data);
},
/*修改风险管控*/
edit(data) {
    return request._post('/shop/plus.ma_risk_control.Index/edit', data);
},
/*删除风险管控*/
del(data) {
    return request._post('/shop/plus.ma_risk_control.Index/del', data);
},
/*风险管控详情*/
detail(data) {
  return request._post('/shop/plus.ma_risk_control.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_risk_control.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_risk_control.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_risk_control.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_risk_control.Index/export', data);
    },
}
export default Ma_risk_controlApi;



// WEBPACK FOOTER //
// ./src/api/ma_risk_control.js